export default __webpack_public_path__ + "static/media/polaroid1video.7ce7b122.mp4";